export default {
  title: 'Bramki płatności',
  fields: {
    name: 'Nazwa',
    payment_gateway: 'Bramki płatności',
    live_from: 'Aktywna od',
    last_30_days_sales: 'Sprzedaż z ostatnich 30 dni',
    kyc_deadlines: 'Terminy KYC',
    actions: 'Akcje',
  },
  stats: {
    active_on_stripe: 'Aktywna na Stripe',
    active_on_adyen: 'Aktywna na Adyen',
    adyen_verification_pending: 'Weryfikacja Adyen w toku',
  },
  filters: {
    search_placeholder: 'Szukaj po nazwie...',
    gateway_status_placeholder: 'Wszystkie bramki',
  },
  not_configured: {
    title: 'Płatności nie są jeszcze skonfigurowane',
    description:
      'Żaden dostawca płatności nie jest podłączony do Twojego konta. Restauracje można w pełni skonfigurować, ale nie będą aktywne ani nie będą przyjmować płatności online, dopóki płatności nie zostaną skonfigurowane.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (Oczekujący)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Zweryfikowany',
    pending: 'Oczekujący',
    rejected: 'Odrzucony',
  },
  buttons: {
    actions: 'Akcje',
    switch_to: 'Przełącz na {{gateway}}',
    view_details: 'Zobacz szczegóły',
    open_onboarding: 'Otwórz onboarding',
    create_onboarding_link: 'Utwórz link onboardingowy',
  },
  modal: {
    title: 'Zmień bramkę płatności',
    description:
      'Czy na pewno chcesz przełączyć {{companyName}} z <bold>{{currentGateway}}</bold> na <bold>{{targetGateway}}</bold>?',
    not_verified_warning:
      '{{gateway}} nie jest zweryfikowany dla tej firmy. Przetwarzanie płatności może być zaburzone.',
    confirm: 'Przełącz',
    cancel: 'Anuluj',
  },
  details_modal: {
    title: '{{companyName}} — Szczegóły bramki płatności',
    requirements: 'Wymagania',
    no_requirements: 'Brak oczekujących wymagań.',
    deadline: 'Termin',
    capabilities: 'Możliwości',
    onboarding_links: {
      section_title: 'Link onboardingowy',
      active_link: 'Aktywny link',
      expires: 'Wygasa {{date}}',
      create_button: 'Utwórz link',
      extend_button: 'Przedłuż link',
      loading: 'Ładowanie linków…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Nie udało się utworzyć linku onboardingowego.',
    switch_success: 'Bramka płatności została pomyślnie zmieniona.',
    switch_failed: 'Nie udało się zmienić bramki płatności.',
    failed_to_load_data: 'Nie udało się załadować danych.',
  },
};
